import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import CompanyNamePICModel from '../../CompanyNamePIC/models/CompanyNamePICModel';

interface CompanyNamePICSelectorState {
    searchResults: CompanyNamePICModel[],
}

const initialState: CompanyNamePICSelectorState = {
    searchResults: [],
}

export const CompanyNamePICSelectorSlice = createSlice({
    name: "CompanyNamePICSelector",
    initialState,
    reducers: {
        setCompanyNamePICSearchResults: (state, action: PayloadAction<CompanyNamePICModel[]>) => {
            state.searchResults = action.payload;
        },
    }
});

export const CompanyNamePICSelectorSelector = createSelector(
    (state: RootState) => state.companyNamePICSelector,
    (data) => data
);

export const {
    setCompanyNamePICSearchResults,
} = CompanyNamePICSelectorSlice.actions;

export default CompanyNamePICSelectorSlice.reducer;